import { STAFFING_WEEK_ROUTE } from "@/ui/Walkthrough/walkthroughRoute";

/**
 * Page modules that something besides their route needs to fetch. A walkthrough fetches its destination's
 * page before navigating there: the tour's anchor scan gives a page only a short window once any anchor is
 * on screen, and the shell's own anchors are there long before a page chunk downloads.
 */
export const loadCallIns = () => import("./pages/CallIns/CallIns");
export const loadDaySchedule = () => import("./pages/DaySchedule/DaySchedule");
export const loadHiringModule = () => import("./pages/HiringModule/HiringModuleWrapper");
export const loadPbjModelPage = () => import("./pages/PbjModel/PbjModelPage");
export const loadScheduleTemplatePage = () => import("./pages/MasterSchedule/ScheduleTemplatePageWrapper");

/**
 * The page each walkthrough launch route renders, keyed by the route template as tours author it. Tours run
 * on desktop only, so the Day view is its desktop page.
 */
export const WALKTHROUGH_ROUTE_PAGE_LOADERS: ReadonlyMap<string, () => Promise<unknown>> = new Map<string, () => Promise<unknown>>([
	["/:departmentId/call-ins", loadCallIns],
	["/:departmentId/day-schedule/:date", loadDaySchedule],
	["/:departmentId/hiring", loadHiringModule],
	["/:departmentId/pbj-model", loadPbjModelPage],
	["/:departmentId/recurring-shifts", loadScheduleTemplatePage],
]);

/** Tour launch routes whose page is already in the first load, so there is nothing to fetch before navigating. */
export const EAGER_WALKTHROUGH_ROUTES: readonly string[] = [STAFFING_WEEK_ROUTE];
